// extracted by css-extract-rspack-plugin
export default {"header":"I6CGbNjNqARKQMDW","ruleId":"_oHgK3VAc86Oc65o","ruleItem":"lwn2ZyLL60UvZZ9h"};